import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/users/index.js'), 'users/index.js')
  resolveStoreModules(require('../store/tf-idf/index.js'), 'tf-idf/index.js')
  resolveStoreModules(require('../store/simulations/index.js'), 'simulations/index.js')
  resolveStoreModules(require('../store/segments/index.js'), 'segments/index.js')
  resolveStoreModules(require('../store/reports/index.js'), 'reports/index.js')
  resolveStoreModules(require('../store/ranking-factors/index.js'), 'ranking-factors/index.js')
  resolveStoreModules(require('../store/projects/index.js'), 'projects/index.js')
  resolveStoreModules(require('../store/filters/index.js'), 'filters/index.js')
  resolveStoreModules(require('../store/estimator-seo/index.js'), 'estimator-seo/index.js')
  resolveStoreModules(require('../store/conclusions/index.js'), 'conclusions/index.js')
  resolveStoreModules(require('../store/clients/index.js'), 'clients/index.js')
  resolveStoreModules(require('../store/analysis/index.js'), 'analysis/index.js')
  resolveStoreModules(require('../store/analysis/analysis-client.js'), 'analysis/analysis-client.js')
  resolveStoreModules(require('../store/clients/client-position.js'), 'clients/client-position.js')
  resolveStoreModules(require('../store/clients/client-results.js'), 'clients/client-results.js')
  resolveStoreModules(require('../store/clients/clients-listing.js'), 'clients/clients-listing.js')
  resolveStoreModules(require('../store/white-cat/target-groups/index.js'), 'white-cat/target-groups/index.js')
  resolveStoreModules(require('../store/white-cat/projects/index.js'), 'white-cat/projects/index.js')
  resolveStoreModules(require('../store/white-cat/industries/index.js'), 'white-cat/industries/index.js')
  resolveStoreModules(require('../store/white-cat/goals/index.js'), 'white-cat/goals/index.js')
  resolveStoreModules(require('../store/white-cat/clients/index.js'), 'white-cat/clients/index.js')
  resolveStoreModules(require('../store/white-cat/analysis/index.js'), 'white-cat/analysis/index.js')
  resolveStoreModules(require('../store/white-cat/analyses/index.js'), 'white-cat/analyses/index.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
